module.exports = __webpack_public_path__ + "img/bitrix24.60c4691a.png";